import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from './api';
import { AuthContext } from './AuthContext';
import { ThemeContext } from './ThemeContext';
import YouTubePlayer from './YouTubePlayer'; // Your YouTube iframe player component
import { ChatbotButton } from './components'; // AI Chatbot component

export default function VideoPlayerPage() {
  const { token, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { videoId } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  useEffect(() => {
    if (!token) return;

    api.get('/api/videos', { headers: { Authorization: 'Bearer ' + token } })
      .then(res => {
        const found = res.data.find(v => v.id === parseInt(videoId));
        if (found) setVideo(found);
        else navigate('/'); // If not found, go back
      })
      .catch(() => {
        alert('Failed to load video');
        navigate('/');
      });
  }, [token, videoId, navigate]);

  if (!video) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="text-primary">{video.title}</h2>
        <div className="d-flex gap-2">
          <button 
            className={`btn btn-outline-${theme === 'dark' ? 'light' : 'dark'}`} 
            onClick={toggleTheme}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            <i className={`bi bi-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
          </button>
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <i className="bi bi-arrow-left me-1"></i>
            Back
          </button>
          <button className="btn btn-outline-danger" onClick={logout}>
            <i className="bi bi-box-arrow-right me-1"></i>
            Logout
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <YouTubePlayer videoId={video.youtube_id} />
      </div>
      
      {/* AI Chatbot */}
      <ChatbotButton 
        theme={theme}
        apiBaseUrl={process.env.REACT_APP_CHATBOT_API_URL || 'http://localhost:8001/api'}
      />
    </div>
  );
}
